import _ from 'lodash';
import seriesMX from '../../../helpers/series';

export default {
	data() {
		return {
			loadingSerial: false
		};
	},
	methods: {
		clientAltered() {
			if (
				this.fields.Empresa
				&& this.loaded
				&& (
					this.fields.Empresa.EmpresaNombre !== this.fields.EmpresaNombre
					|| this.fields.Empresa.EmpresaCIF !== this.fields.EmpresaCIF
				)) {
				this.fields.Empresa = null;
			}
		},
		clientChange(client) {
			if (typeof client === 'object') {
				this.fields.Empresa = client.data;
				this.fields.EmpresaNombre = client.data.EmpresaNombre;
				this.fields.EmpresaDomicilioSocial = client.data.EmpresaDomicilioSocial;
				this.fields.EmpresaCP = client.data.EmpresaCP;
				this.fields.EmpresaLocalidad = client.data.EmpresaLocalidad;
				this.fields.EmpresaProvincia = client.data.EmpresaProvincia;
				this.fields.EmpresaPais = client.data.EmpresaPais;
				this.fields.EmpresaCIF = client.data.EmpresaCIF;
			} else {
				this.clientAltered();
			}
		},
		productChange(item, index) {
			if (this.fields.Conceptos[index] && this.loaded) {
				if (typeof item === 'object' && item.data) {
					this.fields.Conceptos[index].Concepto = item.data.ProductoNombre;
					this.fields.Conceptos[index].Precio = item.data.ProductoPrecio;
				} else {
					this.fields.Conceptos[index].Concepto = '';
				}
			}
		},
		async serialChange(item) {
			if (!this.loadingSerial) {
				this.loadingSerial = true;

				if (item.data) {
					const data = await seriesMX.getSerialValue(item.data._EntityId);

					if (data) {
						this.taxes.iva = data.SerieIVA;
						this.taxes.irpf = data.SerieIRPF;
					}

					this.$vault.set('storedSerial', _.cloneDeep(item));
				}

				this.loadingSerial = false;
			}
		}
	}
};
